import { createTheme } from '@mui/material/styles';
import { green, purple } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(0, 29, 61)',
    },
    secondary: {
      main: '#ff4f58',
    },
  },
});